import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getApiData, getApiRecord } from 'services/RateCardService'

export const getData = createAsyncThunk(
    'rateCard/data/getData',
    async (data) => {
        const response = await getApiData(data)
        return response.data
    },
)

export const getRecord = createAsyncThunk(
    'rateCard/data/getRecord',
    async (id) => {
        const response = await getApiRecord(id)
        const data = {
            ...response.data,
            company: parseInt(response.data?.assignment?.company_id),
            client: response.data?.assignment?.client_id,
            transport_provider: response.data.assignment.transport_provider,
            service: response.data.assignment.service,
        }
        return data
    },
)

const recordData = {
    company: '',
    client: '',
    transport_provider: '',
    service: '',
    start_date: '',
    end_date: '',
    from_location: '',
    from_zipcode: 0,
    from_longitude: 0,
    from_latitude: 0,
    to_location: '',
    to_zipcode: 0,
    to_longitude: 0,
    to_latitude: 0,
    lane: '',
    weight: 0,
    weight_uom: '',
    cube: 0,
    cube_uom: '',
    minimum: 0,
    basic: 0,
    rate: 0,
    weight_slabs: '',
}

const initialTableData = {
    total: 0,
    pageIndex: 1,
    pageSize: 10,
    query: '',
    selectedTab: '',
    service: '',
    sort: [{ column: '', dir: '' }],
}

const dataSlice = createSlice({
    name: 'rateCard/data',
    initialState: {
        loading: false,
        view: recordData,
        data: [],
        tableData: initialTableData,
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.tableData = payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getData.pending, (state) => {
                state.loading = true
                state.tableData.total = 0
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload?.results
                state.tableData.total = payload?.count
            })
            .addCase(getData.rejected, (state) => {
                state.loading = false
                state.data = []
            })
            .addCase(getRecord.fulfilled, (state, { payload }) => {
                state.loading = false
                state.record = payload
            })
            .addCase(getRecord.pending, (state) => {
                state.loading = true
                state.record = null
            })
            .addCase(getRecord.rejected, (state) => {
                state.loading = false
                state.record = null
            })
    },
})

export const { setData, setTableData } = dataSlice.actions

export default dataSlice.reducer
